import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { TomosSection } from './components/TomosSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { DifferentialSection } from './components/DifferentialSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  return <div className="min-h-screen bg-[#0a0a0a] text-[#F5F5F5] font-sans selection:bg-[#F59E0B] selection:text-[#0a0a0a]" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <TomosSection data-id="element-7" />
        <BonusesSection data-id="element-8" />
        <BenefitsSection data-id="element-9" />
        <DifferentialSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <OfferSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FaqSection data-id="element-14" />
        <FinalCtaSection data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
      <PurchaseNotification data-id="element-17" />
    </div>;
}